<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
</style>

<template>
  <div class="create-user-component">
    <vx-card class="grid-view-item mb-base overflow-hidden">
      <vx-tooltip :text="$t('Labels.Edit')" class="float-right" color="primary" >
        <vs-button  @click="edit(uuid)" class="watersonic edit-button mr-2 mt-2" color="primary" icon="icon-edit" icon-pack="feather" type="filled"></vs-button>
      </vx-tooltip>
      <vx-tooltip :text="$t('Labels.Delete')" class="float-right" color="primary" >
        <vs-button  @click="requestPassword()" class="watersonic edit-button mr-2 mt-2" color="primary" icon="icon-trash" icon-pack="feather" type="filled"></vs-button>
      </vx-tooltip>
      <h4>{{$t('Labels.Detail')}}</h4>
      <table cellspancing="5" class="border-separate mt-5" v-if="response">
        <tbody>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Name')}}</td>
            <td class=" px-2 py-1">{{response.name}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Description')}}</td>
            <td class=" px-2 py-1">{{response.description}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Organization')}}</td>
            <td class=" px-2 py-1">{{response.organization_id}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Profile')}}</td>
            <td class=" px-2 py-1">{{response.service_profile_uuid}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Network')}}</td>
            <td class=" px-2 py-1">{{response.id_nw}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.CreatedAt')}}</td>
            <td class=" px-2 py-1">{{response.created_at}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Creator')}}</td>
            <td class=" px-2 py-1">{{response.user_creator.first_name + ' ' + response.user_creator.last_name}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.UpdatedAt')}}</td>
            <td class=" px-2 py-1">{{response.updated_at}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Creator')}}</td>
            <td class=" px-2 py-1">{{response.user_update != null ? response.user_update.first_name + ' ' + response.user_update.last_name:''}}</td>
          </tr>
        </tbody>
      </table>
    </vx-card>
    <div class="w-full">
      <vx-card class="grid-view-item mb-base overflow-hidden">
        <h4>{{$t('Labels.Assignments')}}</h4>
      <table cellspancing="5" class="border-separate mt-5" v-if="response">
        <tbody>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$tc('Labels.Device',2)}}</td>
            <td class=" px-2 py-1">{{response.devices == null ? '0' :response.devices}}</td>
            <td class=" px-2 py-1">
              <vs-button @click="goDevices()" type="flat">{{$t("Labels.GoTo") + ' ' + $tc("Labels.Device",2)}}</vs-button>
            </td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Licenses')}}</td>
            <td class=" px-2 py-1">{{response.licenses == null ? '0' :response.licenses}}</td>
             <td class=" px-2 py-1">
               <vs-button @click="goLicenses()" type="flat">{{$t("Labels.GoTo") + ' ' + $t("Labels.Licenses")}}</vs-button>
             </td>
          </tr>
        </tbody>
      </table>
    </vx-card>
    </div>
    <div class="w-full">
        <vx-card class="grid-view-item mb-base overflow-hidden address-card">
            <div style="width: 100%">
                <select class="vs-vs-inputx vs-input--input mb-3" v-model="logLimit" style="float: right; width: 90px;" @change="getResponse()">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            <h4>{{$t('ChangeHistory')}}</h4>
            <vs-table v-if="logData" :data="logData">
              <template slot="thead">
                <vs-th sort-key="name">
                  {{$t('Labels.CreatedAt')}}
                </vs-th>
                <vs-th sort-key="name">
                  {{$t('Labels.Name')}}
                </vs-th>
                <vs-th sort-key="organization">
                  {{$t('Labels.Organization')}}
                </vs-th>
                <vs-th sort-key="user.first_name">
                  {{$t('Labels.Modifier')}}
                </vs-th>
              </template>

              <template  slot-scope="{data}">
                <vs-tr :data="item" :key="index" v-for="(item, index) in data" >
                  <vs-td :data="item.createdAt">
                    {{item.createdAt}}
                  </vs-td>
                  <vs-td :data="item.name">
                    {{item.name}}
                  </vs-td>
                  <vs-td :data="item.organization_id">
                    {{item.organization_id}}
                  </vs-td>
                  <vs-td :data="item.user.first_name">
                    {{item.user.first_name + ' ' + item.user.last_name}}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
        </vx-card>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import listItem from '@/components/listItem/listItem.vue'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'


export default {
  components: {
    listItem
  },
  data () {
    return {
      response:{},
      uuid:this.$route.params.uuid, 
      logLimit: 5,
      logData: []
    }
  },

  methods: {
    async getData () {
      const params = {
        url: `applications/${this.uuid}`,
        method: 'GET',
        params: {
          limit: this.logLimit
        }
      }
      await request(params).then(response => {
        this.response = response.data.data
        if (this.response.applications_records != null) this.logData = this.response.applications_records
      })
    },

    edit (uuid) {
      window.location.href = `/apps/${  this.uuid  }/update`
    },
    requestPassword () {
      globalPassActions.show()
    },
    async doDelete () {
      const params = {
        url: `devices/${this.uuid}`,
        method: 'DELETE',
        params: {}
      }
      await request(params).then(response => {
      })       
    },
    goDevices () {
      window.location.href = `/devices?app=${this.response.id_nw}`
    },
    goLicenses (uuid) {
      window.location.href = `/licenses?app=${this.response.id_nw}`
    }
  },
  mounted () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.Apps')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.Detail')
    this.$route.meta.pageTitle = this.$t('Path.Detail')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
    this.getData()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    } 
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) this.doDelete()
    }
  }
}
</script>
